<template>
  <UIcon name="i-mdi-loading" class="animate-spin"></UIcon>
</template>

<script setup lang="ts"></script>
